import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Login() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    identifier: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError("");

    try {
      const payload = { password: form.password };

      if (form.identifier.includes("@")) {
        payload.email = form.identifier;
      } else {
        payload.userId = form.identifier;
      }

      const res = await fetch("https://algoxpo.online/api/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Login failed");
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("userId", data.userId);

      navigate("/dashboard");
    } catch (err) {
      setError("Server Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.overlay}></div>

      <div style={styles.container}>
        {/* LOGO */}

        <img src={logo} alt="logo" style={styles.logo} />

        {/* CARD */}

        <form style={styles.card} onSubmit={submit}>
          <h1 style={styles.title}>Welcome Back</h1>

          <p style={styles.subtitle}>Login to your account</p>

          {error && <div style={styles.error}>{error}</div>}

          {/* USER ID */}

          <div style={styles.inputBox}>
            <input
              type="text"
              name="identifier"
              placeholder="Email or Username"
              value={form.identifier}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          {/* PASSWORD */}

          <div style={styles.inputBox}>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              required
              style={styles.input}
            />

            <span
              style={styles.eye}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "🙈" : "👁"}
            </span>
          </div>

          {/* OPTIONS */}

          <div style={styles.options}>
            <label style={styles.remember}>
              <input type="checkbox" />
              Remember Me
            </label>

            <Link to="/forgot-password" style={styles.link}>
              Forgot Password?
            </Link>
          </div>

          {/* LOGIN BUTTON */}

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? "Logging In..." : "Login"}
          </button>

          {/* SOCIAL */}

          <div style={styles.divider}>
            <span>Or continue with</span>
          </div>

          <div style={styles.socials}>
            <button type="button" style={styles.socialBtn}>
              G
            </button>

            <button type="button" style={styles.socialBtn}>
              Git
            </button>

            <button type="button" style={styles.socialBtn}>
              D
            </button>
          </div>

          {/* REGISTER */}

          <p style={styles.signupText}>
            Don't have an account?{" "}
            <Link to="/register" style={styles.signupLink}>
              Sign Up
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    background:
      "radial-gradient(circle at top, #003566 0%, #000814 45%, #000000 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    padding: "20px",
    boxSizing: "border-box",
    fontFamily: "Inter, sans-serif",
  },

  overlay: {
    position: "absolute",
    width: "700px",
    height: "700px",
    background: "rgba(0,140,255,0.12)",
    filter: "blur(140px)",
    borderRadius: "50%",
  },

  container: {
    width: "100%",
    maxWidth: "420px",
    position: "relative",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  logo: {
    width: "260px",
    marginBottom: "10px",
    objectFit: "contain",
  },

  card: {
    width: "100%",
    background: "rgba(0,0,0,0.45)",
    border: "1px solid rgba(255,255,255,0.08)",
    backdropFilter: "blur(14px)",
    borderRadius: "26px",
    padding: "35px 28px",
    boxSizing: "border-box",
    boxShadow: "0 0 40px rgba(0,0,0,0.45)",
  },

  title: {
    textAlign: "center",
    color: "#fff",
    fontSize: "40px",
    marginBottom: "10px",
    fontWeight: "700",
  },

  subtitle: {
    textAlign: "center",
    color: "#94a3b8",
    marginBottom: "30px",
    fontSize: "16px",
  },

  error: {
    background: "rgba(255,0,0,0.15)",
    color: "#ff8080",
    padding: "12px",
    borderRadius: "10px",
    textAlign: "center",
    marginBottom: "18px",
    fontSize: "14px",
  },

  inputBox: {
    position: "relative",
    marginBottom: "18px",
  },

  input: {
    width: "100%",
    padding: "16px",
    borderRadius: "14px",
    border: "1px solid rgba(255,255,255,0.08)",
    background: "rgba(255,255,255,0.05)",
    color: "#fff",
    fontSize: "15px",
    outline: "none",
    boxSizing: "border-box",
  },

  eye: {
    position: "absolute",
    right: "16px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "#94a3b8",
    fontSize: "18px",
  },

  options: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "22px",
    flexWrap: "wrap",
    gap: "10px",
  },

  remember: {
    color: "#cbd5e1",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  link: {
    color: "#00b4ff",
    textDecoration: "none",
    fontSize: "14px",
  },

  button: {
    width: "100%",
    padding: "15px",
    borderRadius: "14px",
    border: "none",
    background: "linear-gradient(90deg,#0077ff,#00c6ff)",
    color: "#fff",
    fontSize: "17px",
    fontWeight: "700",
    cursor: "pointer",
    transition: "0.3s",
  },

  divider: {
    textAlign: "center",
    marginTop: "28px",
    marginBottom: "20px",
    color: "#94a3b8",
    fontSize: "14px",
  },

  socials: {
    display: "flex",
    justifyContent: "center",
    gap: "16px",
    flexWrap: "wrap",
  },

  socialBtn: {
    width: "58px",
    height: "58px",
    borderRadius: "16px",
    border: "1px solid rgba(255,255,255,0.08)",
    background: "rgba(255,255,255,0.05)",
    color: "#fff",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "18px",
  },

  signupText: {
    textAlign: "center",
    color: "#cbd5e1",
    marginTop: "26px",
    fontSize: "15px",
  },

  signupLink: {
    color: "#00b4ff",
    textDecoration: "none",
    fontWeight: "bold",
  },
};
